
<template>
    <div class="page">
      <v-container fluid>
        <v-form ref="form">
            <div v-if="form.filters.analitico">
                <v-row class="d-flex justify-center mt-3">
                    <v-col cols="2">
                        <v-autocomplete
                            v-model="form.filters.greIdAnalitico"
                            label="GRE"
                            dense
                            outlined
                            item-text="nome"
                            item-value="codigo"
                            :items="form.lists.listaGerenciasRegionais"
                            @change="atualizarEscolasPorGre(form.filters.greIdAnalitico)"
                        />
                    </v-col>
                    <v-col cols="2">
                        <v-autocomplete
                            v-model="form.filters.escolaIdAnalitico"
                            label="Escola"
                            dense
                            outlined
                            item-text="nome"
                            item-value="codigo"
                            :items="form.lists.listaEscolas"
                            @focus="validarSeTemGre"
                            
                        />
                    </v-col>
                    <v-col cols="4">
                        <v-text-field
                        label="Formação"	
                        v-model="form.filters.formacaoAnalitico"
                        outlined
                        dense
                        ></v-text-field>
                    </v-col>
   
                </v-row>
                <v-row class="d-flex justify-center mt-3">
                    <sigfoco-date-picker
                        :cols="2"
                        label="Data Início"
                        v-model="form.filters.dataInicioAnalitico"
                        removeIcon
                        outlined
                        dense
                  ></sigfoco-date-picker>
                  <sigfoco-date-picker
                    :cols="2"
                    v-model="form.filters.dataFimAnalitico"
                    label="Data Final"
                    removeIcon
                    outlined
                    dense
                  ></sigfoco-date-picker>
                  <sigfoco-switch-button
                    :cols="2"
                    v-model="form.filters.analitico"
                    label="Tipo de Relatório"
                    labelChecked="Analítico"
                    labelUnchecked="Sintético"
                ></sigfoco-switch-button>
                </v-row>
            </div>
            <div v-else>
                <v-row class="d-flex justify-center mt-3">
                    <v-col cols="2">
                        <v-autocomplete
                            v-model="form.filters.greIdSintetico"
                            label="GRE"
                            dense
                            outlined
                            item-text="nome"
                            item-value="codigo"
                            :items="form.lists.listaGerenciasRegionais"
                            @change="atualizarEscolasPorGre(form.filters.greIdSintetico)"
                        />
                    </v-col>
                    <v-col cols="2">
                        <v-autocomplete
                            v-model="form.filters.escolaIdSintetico"
                            label="Escola"
                            dense
                            outlined
                            item-text="nome"
                            item-value="codigo"
                            :items="form.lists.listaEscolas"
                            @focus="validarSeTemGre"
                        />
                    </v-col>
                    <v-col cols="2">
                        <v-text-field
                        label="Carga Horária Total"	
                        v-model="form.filters.cargaHorariaSintetico"
                        outlined
                        @keypress="$validarEntradaNumericaComVirgula"
                        inputmode="numeric"
                        dense
                        maxle
                        maxlength="5"
                        ></v-text-field>
                    </v-col>
                    <sigfoco-switch-button
                        :cols="2"
                        v-model="form.filters.analitico"
                        label="Tipo de Relatório"
                        labelChecked="Analítico"
                        labelUnchecked="Sintético"
                    ></sigfoco-switch-button>
                </v-row>
                <v-row class="d-flex justify-center mt-3">
                    <sigfoco-date-picker
                        :cols="2"
                        label="Data Início"
                        v-model="form.filters.dataInicioSintetico"
                        removeIcon
                        outlined
                        dense
                    ></sigfoco-date-picker>
                    <sigfoco-date-picker
                        :cols="2"
                        v-model="form.filters.dataFimSintetico"
                        label="Data Final"
                        removeIcon
                        outlined
                        dense
                    ></sigfoco-date-picker>
                </v-row>
            </div>
            <div class="text-center">
                <v-col cols="12">
                    <sigfoco-tooltip
                        text="Buscar"
                        icon="mdi-magnify"
                        @click="buscarRelatorios"
                    ></sigfoco-tooltip>
                    <sigfoco-tooltip
                        text="Limpar"
                        icon="mdi-eraser"
                        @click="resetForm"
                    ></sigfoco-tooltip>
                </v-col>
            </div>
        </v-form>
        <v-data-table
          v-if="form.mostrarAnalitico"
          class="mt-5 printable"
          :headers="getFilteredHeader(headersAnalitico)"
          :items="form.lists.listRelatorioAnalitico"
          :items-per-page="form.itemsPerPage"
          :footer-props="$footerProps"
        >
          <template v-slot:[`item.gre`]="{ item }">
            {{ item.gre }}
          </template>
          <template v-slot:[`item.nomeEscolaComInep`]="{ item }">
            {{ item.nomeEscolaComInep }}
          </template>
          <template v-slot:[`item.formacao`]="{ item }">
            {{ item.formacao }}
          </template>
          <template v-slot:[`item.cargaHoraria`]="{ item }">
            {{ item.cargaHoraria }}
          </template>
        </v-data-table>
        <v-data-table
            v-else
            class="mt-5 printable"
            :headers="getFilteredHeader(headersSintetico)"
            :items="form.lists.listRelatorioSintetico"
            :items-per-page="form.itemsPerPage"
            :footer-props="$footerProps"
        >
            <template v-slot:[`item.gre`]="{ item }">
            {{ item.gre }}
            </template>
            <template v-slot:[`item.escola`]="{ item }">
            {{ item.escola }}
            </template>
            <template v-slot:[`item.cargaHorariaTotal`]="{ item }">
            {{ item.cargaHorariaTotal }}
            </template>
            <template v-slot:[`item.quantidadeFormacoes`]="{ item }">
            {{ item.quantidadeFormacoes }}
            </template>
            <template v-slot:[`item.quantidadeDeParticipantesPrevista`]="{ item }">
            {{ item.quantidadeDeParticipantesPrevista }}
            </template>
            <template v-slot:[`item.quantidadeDeParticipantesPresentes`]="{ item }">
            {{ item.quantidadeDeParticipantesPresentes }}
            </template>
            <template v-slot:[`item.quantidadeDeParticipantesAusentes`]="{ item }">
            {{ item.quantidadeDeParticipantesAusentes }}
            </template>

        </v-data-table>
        <sigfoco-buttons
          v-if="form.lists.listRelatorioAnalitico.length > 0 || form.lists.listRelatorioSintetico.length > 0"
          actionText="Baixar PDF"
          cancelText="Baixar CSV"
          @click="baixarRelatorioPdf"
          @cancel="baixarCSVRelatorio"
        ></sigfoco-buttons>
      </v-container>
    </div>
  </template>
  
<script>
import pageLoadingMixin from "mixins/page-loading.mixin";
import RelatorioSinteticoAnalitico from "services/relatorios-sintetico-analiticos/solicitacao-formacao.service";
import ManterSetorService from "~/services/manter-setor.service";
import FormacaoService from "~/services/manter-formacao.service";    
export default {
    name: "RelatorioSolicitacaoFormacaoPorEscola",
    mixins: [pageLoadingMixin, RelatorioSinteticoAnalitico, ManterSetorService, FormacaoService],
    data: () => ({
    onReport: false,
    expanded: [],
    form: {
        filters: {
            analitico: true,
            // analitico
            formacaoAnalitico: null,
            greIdAnalitico: null,
            escolaIdAnalitico: null,
            dataInicioAnalitico: null,
            dataFimAnalitico: null,
            // sintetico
            greIdSintetico: null,
            escolaIdSintetico: null,
            dataInicioSintetico: null,
            dataFimSintetico: null,
            cargaHorariaSintetico: null,
        },
        lists: {
            listRelatorios: [],
            listRelatorioAnalitico: [],
            listRelatorioSintetico: [],
            listaGerenciasRegionais: [],
            listaEscolas: [],
        },
        itemsPerPage: 10,
        mostrarAnalitico: true,
    },
    headersAnalitico: [
        { text: "GRE", align: "center", value: "gre" },
        { text: "Escola", align: "center", value: "nomeEscolaComInep" },
        { text: "Formação", align: "center", value: "formacao" },
        { text: "Carga Horária", align: "center", value: "cargaHoraria" },
    ],
    headersSintetico: [
        { text: "GRE", align: "center", value: "gre" },
        { text: "Escola", align: "center", value: "escola" },
        { text: "Carga Horária Total", align: "center", value: "cargaHorariaTotal" },
        { text: "Quantidade de Formações", align: "center", value: "quantidadeFormacoes" },
        { text: "Quantidade Prevista de Participantes", align: "center", value: "quantidadeDeParticipantesPrevista" },
        { text: "Quantidade de Participantes Presentes", align: "center", value: "quantidadeDeParticipantesPresentes" },
        { text: "Quantidade de Participantes Ausentes", align: "center", value: "quantidadeDeParticipantesAusentes" },
    ],
    }),
    watch: {
        "form.filters.analitico"(novoValor) {
            this.form.mostrarAnalitico = novoValor;
            this.resetForm();
        }
    },

    computed: {
        isAnalitico() {
            return this.form.filters.analitico;
        },
    },
    methods: {
        getFilteredHeader(headers) {
            return headers.filter(header => {
            if (header.onlyView) return !this.onReport;
            if (header.onlyReport) return this.onReport;
            return true;
            });
        },
        buscarRelatorios() {
            const isValid = this.validarDatas();
            if (!isValid) return;
            const preparedRequest = this.prepararRequisicao();
                const buscarRelatorio = (request) => {
                return this.$obterRelatorioSolicitacaoFormacaoPorEscola(request);
                };
                buscarRelatorio(this.$montarParamsFilters(preparedRequest)).then(
                ({ data }) => {
                    this.form.mostrarAnalitico = this.isAnalitico;
                    this.isAnalitico ? this.form.lists.listRelatorioAnalitico = data.relatorio?.listaAnalitico: this.form.lists.listRelatorioSintetico = data.relatorio?.listaSintetico; 
                }
            );
        },
        validarDatas() {
            const { dataInicioAnalitico, dataFimAnalitico, dataInicioSintetico, dataFimSintetico } = this.form.filters;
            const msgData = "A Data Início precisa ser anterior à Data Final";
            if (dataInicioAnalitico && dataFimAnalitico) {
                if (new Date(dataInicioAnalitico) > new Date(dataFimAnalitico)) {
                    this.$notifyWarning(msgData);
                    return false;
                }
            }
            if (dataInicioSintetico && dataFimSintetico) {
                if (new Date(dataInicioSintetico) > new Date(dataFimSintetico)) {
                    this.$notifyWarning(msgData);
                    return false;
                }
            }

            return true;
        },
        async baixarCSVRelatorio() { 
            const preparedRequest = this.prepararRequisicao();
            this.showPageLoading();
            try {
                const { data } = await (this.$obterRelatorioCSVSolicitacaoFormacaoPorEscola(this.$montarParamsFilters(preparedRequest))
                );
                this.$baixarRelatorioCSV(data, `SIGFOCO.RelatórioDeDeFormaçãoPorEscola`);
                this.$notifySuccess("Operação realizada com sucesso.");
            } finally {
                this.hidePageLoading();
            }
        },

        async baixarRelatorioPdf() {
            const preparedRequest = this.prepararRequisicao();
            this.showPageLoading();
            try {
                const { data } = await (this.$obterRelatorioPDFSolicitacaoFormacaoPorEscola(this.$montarParamsFilters(preparedRequest)));

                const url = URL.createObjectURL(data);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "SIGFOCO.RelatórioDeFormaçãoPorEscola.pdf");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                this.$notifySuccess("Operação realizada com sucesso.");
            } finally {
                this.hidePageLoading();
            }
        },

        prepararRequisicao() {
            if (this.isAnalitico) {
            return {
                formacao: this.form.filters.formacaoAnalitico,
                greCodigo: this.form.filters.greIdAnalitico,
                escolaCodigo: this.form.filters.escolaIdAnalitico,
                dataInicio: this.form.filters.dataInicioAnalitico,
                dataFim: this.form.filters.dataFimAnalitico,
                isAnalitico: this.isAnalitico,
            };
            } else {
            return {
                greCodigo: this.form.filters.greIdSintetico,
                escolaCodigo: this.form.filters.escolaIdSintetico,
                cargaHorariaTotal: this.form.filters.cargaHorariaSintetico,
                dataInicio: this.form.filters.dataInicioSintetico,
                dataFim: this.form.filters.dataFimSintetico,
                isAnalitico: this.isAnalitico,
            };
            }
        },
        resetForm() {
            this.form.filters.dataInicioAnalitico = null;
            this.form.filters.dataFimAnalitico = null;
            this.form.filters.dataInicioSintetico = null;
            this.form.filters.dataFimSintetico = null;

            this.$nextTick(() => {
            this.$set(this.form.filters, 'dataInicioAnalitico', null);
            this.$set(this.form.filters, 'dataFimAnalitico', null);
            this.$set(this.form.filters, 'dataInicioSintetico', null);
            this.$set(this.form.filters, 'dataFimSintetico', null);
            });
            this.form.filters.formacaoAnalitico = null;
            this.form.filters.greIdAnalitico = null;
            this.form.filters.escolaIdAnalitico = null;
            this.form.filters.greIdSintetico = null;
            this.form.filters.escolaIdSintetico = null;
            this.form.filters.cargaHorariaSintetico = null;
            this.form.lists.listRelatorioAnalitico = [];
            this.form.lists.listRelatorioSintetico = [];
            this.form.lists.listaEscolas = [];
        },
        atualizarEscolasPorGre(greId) {
            this.form.filters.escolaIdSintetico = null;
            this.form.filters.escolaIdAnalitico = null;
            this.$obterListaEscolas({ gres: greId })
                .then(({ data }) => {
                    this.form.lists.listaEscolas = data.lista;
                });
        },
        validarSeTemGre() {
            if ((this.isAnalitico && !this.form.filters.greIdAnalitico) || 
                (!this.isAnalitico && !this.form.filters.greIdSintetico)) {
                this.$notifyWarning("Por favor, escolha a GRE de cobertura da escola.");
                return false;
            }
            return true;
        },
    },
    mounted() {
        this.$obterListaGerenciasRegionais().then(({ data }) => {
            this.form.lists.listaGerenciasRegionais = data.lista;
        });
    }
};
</script>
<style scoped>
.permissoes {
  padding: 1em !important;
  text-align: center;
  font-weight: 500;
}
.permissao {
  padding-right: 0.5em;
}
</style>